<template>
    <div class="card-box p-0 over_hide">
        <div class="header_items_dash">
            <div class="w_full">
                <h4 class="header-title m-t-0 m-b-7 text-dark t_overflow">{{ $t('scheduled_emails') }}</h4>
                <small class="show text-muted f_size_12 t_overflow">{{ $t('the_following_emails_will_be_sent_soon') }}</small>
            </div>
            <button @click.prevent="showAllEmails()" class="btn btn-white btn-sm">{{ $t("show_all") }}</button>
        </div>
        <ul class="list_items_dash">
            <router-link v-for="item in list" tag="li" :to="`/deals/${item.deal.id}/emails`" :key="item.id">
                <div class="photo_lead">
                    <img :src="item.deal.lead.avatar || '/static/images/avatar.jpg'" title="Nome do Lead" class="img-circle thumb-sm">
                </div>
                <div class="w_full">
                    <div class="d_flex">
                        <p class="m-b-4 f_size_13 c_default w_full">
                            <strong>#{{item.deal.code}}<span v-if="item.deal.lead.full_name !== item.deal.lead.email"> - {{item.deal.lead.full_name}}</span></strong>
                            <small class="show t_overflow text-muted" v-if="item.deal.lead.reference">({{item.deal.lead.reference}})</small>
                        </p>
                        <small class="f_size_10 text-muted text-right w_70">{{ item.scheduled_at | pmlDate('DD/MM/YYYY HH:mm') }}</small>
                    </div>
                    <p class="show t_overflow f_size_12 m-0">{{item.subject}}</p>
                </div>
            </router-link>
            <PmlInfiniteLoading @infinite="infiniteHandler($event)" ref="infiniteLoading" spinner="wavedots">
                <span slot="no-more"></span>
                <span slot="no-results"></span>
                <span v-if="list.length === total && !isLoading" slot="spinner"></span>
            </PmlInfiniteLoading>
            <router-link :to="{ name: 'sent-emails.create' }" tag="li" class="null_item"  v-if="!list.length && !isLoading">
                <div class="clearfix text-center">
                    <div class="icon_svg m-b-5">
                        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 57 57" xml:space="preserve"><g><g><polygon points="0,5 0,44 28,44 56,44 56,5 " style="fill: rgb(199, 207, 226);"></polygon><path d="M30.965,27.107c-1.637,1.462-4.292,1.462-5.93,0l-2.087-1.843C16.419,31.091,0,44,0,44h21.607h12.787H56c0,0-16.419-12.909-22.948-18.736L30.965,27.107z" style="fill: rgb(224, 228, 239);"></path><path d="M0,5l25.035,22.107c1.637,1.462,4.292,1.462,5.93,0L56,5H0z" style="fill: rgb(239, 242, 250);"></path></g><g><circle cx="46" cy="41" r="11" style="fill: rgb(118, 201, 176);"></circle><path d="M52,40h-5v-5c0-0.552-0.447-1-1-1s-1,0.448-1,1v6c0,0.552,0.447,1,1,1h6c0.553,0,1-0.448,1-1S52.553,40,52,40z" style="fill: rgb(255, 255, 255);"></path></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
                    </div>
                    <small class="show m-b-5">{{ $t('no_scheduled_email_found') }}</small>
                    <p class="bold m-0 c_blue">{{ $t('schedule_an_email') }}</p>
                </div>
            </router-link>
        </ul>
    </div>
</template>

<script>
    import { getAllPaged } from '@/services/emails'
    import { mapGetters } from 'vuex'
    import PmlInfiniteLoading from 'vue-infinite-loading'
    import moment from 'moment'
    import bus from 'utils/events/bus'

    export default {
        name: 'NextScheduledEmails',
        components: {
            PmlInfiniteLoading
        },
        data () {
            return {
                isLoading: true,
                list: [],
                page: 0,
                total: 0,
                paginate: 10,
                scheduled_at_from: moment().format('DD/MM/YYYY')
            }
        },
        computed: {
            ...mapGetters({
                'member': 'getMember'
            })
        },
        created () {
            bus.$on('refreshEmailsCard', this.clearInfinity)
        },
        methods: {
            getAllPaged ($state) {
                this.isLoading = true
                getAllPaged(
                    this.page + 1,
                    {
                        status_s: ['scheduled'],
                        orderBy: 'scheduled_at',
                        scheduled_at_from: this.scheduled_at_from,
                        paginate: this.paginate,
                        member_id: this.member.id,
                        relations: ['deal.lead']
                    }
                )
                    .then((response) => {
                        this.list.push(...response.data.data)
                        this.page = response.data.current_page
                        this.total = response.data.total

                        $state.loaded()
                        if (this.list.length === this.total)
                            $state.complete()
                    })
                    .then(() => { this.isLoading = false })
            },
            infiniteHandler ($state) {
                setTimeout(() => {
                    this.getAllPaged($state)
                }, 1000)
            },
            showAllEmails () {
                window.localStorage.setItem('pml_emails_status_s', ['scheduled'])
                this.$router.push({ name: 'emails.index' })
            },
            clearInfinity () {
                this.isLoading = true
                this.list = []
                this.page = 0
                this.total = 0
                this.$nextTick(() => {
                    if (typeof this.$refs['infiniteLoading'] !== 'undefined')
                        this.$refs['infiniteLoading'].$emit('$InfiniteLoading:reset')
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/dashboard/components/widgets/NextScheduledEmails.vue